import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent, LoaderService, UrlUtil, CfetService, CFETILMEndpointsConstant, CfetPageNamesConstant } from '../../cfet-core';

@Component({
    selector: 'app-affiliation-code',
    templateUrl: './affiliation-code.component.html',
    styleUrls: ['./affiliation-code.component.scss'],
    standalone: false
})
export class AffiliationCodeComponent extends CfetBaseComponent implements OnInit {

  orgDetailInfo: { org_name: any; address: any; city: any; state: any; zipcode: any; isPSEAffliationcode: any };
  companyInfo: {};
  checkstateAndZip = { 'state': '', 'zipcode': '' };
  showLoading: boolean = false;
  jobfunction: any;
  orgId: any;
  getorgInfo: any;
  public affiliateName: string;
  addressLine2: any;
  orgCity: any;
  zipCodePin: any;
  orgState: any;
  orgStreetAddress: any;
  isSpaOrg: any;
  streetAddress: any;
  org_name: any;

  constructor(private router: Router,
    private loaderService: LoaderService,
    private cfetService: CfetService,
    private urlUtil: UrlUtil,
    private title: Title) { super(); }

  ngOnInit () {
    window.scrollTo(0, 0);
    this.title.setTitle(this.cfetTitles.agency.htmlTitle);
    this.cfetService.isLandingPage.next(false);
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      this.getorgInfo = JSON.parse(sessionStorage.getItem('orgInfo'));
      this.orgId = this.getorgInfo.orgid;
      this.affiliateName = this.getorgInfo.orgName;
      this.isSpaOrg = this.getorgInfo.isSpaOrg;
    }
  }

  getOrgProfile () {
    this.companyInfo = {};
    if (this.orgId.length > 0) {
      this.showLoading = true;
      const param = { xorgid: this.orgId };
      const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_ORG_PROFILE, param)}`;
      this.navigateToCustomerEligibility(url);
    }
  }

  continue (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (!this.getorgInfo.isSpaOrg) {
        this.getOrgProfile();
      }
    }
  }

  cancel (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_LANDING]);
    }
  }

  navigateToCustomerEligibility(url) {
    this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
      this.showLoading = false;
      window.scrollTo(0, 0);
      if (data && data.profile) {
        this.setCompanyInfo(data);
        // Show Organization Details for Non spa org
        sessionStorage.setItem('orgDetailInfo', JSON.stringify(this.orgDetailInfo));
        this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY]);
      }
    }, (_error) => {
      this.loaderService.hideLoading();
    });
  }

  setCompanyInfo(data) {
    data.profile.forEach(val => {
      this.companyInfo[val.attribute_name] = val.attribute_value ?? val.attribute_mvalue;
    });
    this.addressLine2 = this.companyInfo['Address 2'] ? this.companyInfo['Address 2'] : '';
    this.streetAddress = (this.addressLine2 !== '') ? (String(this.companyInfo['Address 1']) + ',' + this.addressLine2) : this.companyInfo['Address 1'];
    this.setOrgDetailInfo(data);
  }

  setOrgDetailInfo(data) {
    this.orgDetailInfo = {
      org_name: data.orgName,
      address: this.streetAddress,
      city: this.companyInfo['city'],
      state: this.companyInfo['state'],
      zipcode: this.companyInfo['zipcode'],
      isPSEAffliationcode: true
    };
  }
}
